export const hoy = new Date();

export const mesAntes = new Date(
  new Date().setMonth(new Date().getMonth() - 1)
);

export const primerDiaAnio = new Date(new Date().getFullYear(), 0, 1);
